import ready, { HTML } from 'Utils';
import {initMobileNav, initAccessibilityNav} from './components/initMobileNav';
import initHeroSlider from './components/initHeroSlider';
import initFancybox from './components/initFancybox';
import initPlayer from './components/initPlayer';
import initCardSlider from './components/initCardSlider';
import initTabs from './components/initTabs';
import initTooltips from './components/initTooltips';
import initShowMore from './components/initShowMore';
import initFixedHeader from './components/initFixedHeader';
import initAnimations from './components/initAnimations';
import {initVimeo, initYoutube} from './components/initVideo';
import initGallery from './components/initGallery';
import initHoverAnimations from './components/initHoverAnimations';
import initParallax from './components/initParallax';
import initActivityFlip from './components/initActivityFlip';

ready(() => {
    HTML.classList.add('is-loaded');
    HTML.classList.add('ready');
});

document.addEventListener('DOMContentLoaded', function () {
    initMobileNav()
    initAccessibilityNav()
    initHeroSlider()
    initFancybox()
    initPlayer()
    initCardSlider()
    initTabs()
    initTooltips()
    initShowMore()
    initFixedHeader()
    initAnimations()
    initHoverAnimations()
    initVimeo()
    initYoutube()
    initGallery()
    initParallax()
    initActivityFlip()
}, false);
